import { ChevronDown } from 'lucide-react';
import { useState } from 'react';

type Option = {
  label: string;
  value: string;
};

type Props = {
  options: any;
  disabled?: boolean;
  className?: string;
  getLabel: any;
};

export default function DropdownMinimal({ options, disabled, className, getLabel }: Props) {
  const [value, setValue] = useState('');

  return (
    <div className="relative w-full">
      <select
        value={value}
        onChange={(e) => setValue(e.target.value)}
        disabled={disabled}
        className={`${className} appearance-none pr-10`}
      >
        <option value="" disabled>
          none selected
        </option>

        {options.map((opt: any) => (
          <option key={opt.value} value={opt.value}>
            {/* {opt.name} */}
            {getLabel(opt)}
          </option>
        ))}
      </select>

      {/* dropdown icon */}
      <ChevronDown
        size={18}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-[#621C43] pointer-events-none"
      />
    </div>
  );
}
